module.exports = __webpack_public_path__ + "img/ico_lingzhuwaiguanlibao.d80435ba.png";